import { trigger, state, style, transition, animate } from '@angular/animations';
import { Component, EventEmitter, Output, TemplateRef, OnInit, Input, Renderer2, Inject } from '@angular/core';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { apiService } from 'app/services/api.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { OriginDestinations, Travellers } from '@core/interfaces/flight';
import { CustomModalComponent } from '@shared/custom-modal/custom-modal.component';
import { FormGroup, FormBuilder, FormControl, FormArray, Validators, AbstractControl } from '@angular/forms';
import { globalData } from "app/services/globalData.service";
import { HttpHeaders } from '@angular/common/http';
import { DOCUMENT } from '@angular/common';

@Component({
    selector: 'app-flight-payment-process',
    templateUrl: './flight-payment-process.component.html',
    styleUrls: ['./flight-payment-process.component.scss'],
})
export class FlightPaymentProcessComponent implements OnInit {

    isPaymentCompleted: boolean = false;
    bookingProcessStart: boolean = false;
    isBookingCompleted: boolean = false;
    isBookingError: boolean = false;
    requestParams: any;
    bookingResponse: any;
    bookingRequest = localStorage.getItem('bookingRequest');

    constructor(private _apiService: apiService,
        private localeService: BsLocaleService,
        private modalService: BsModalService,
        private formBuilder: FormBuilder,
        public activatedRoute: ActivatedRoute,
        public global: globalData,
        private _renderer2: Renderer2,
        @Inject(DOCUMENT) private _document: Document
      ) {
        
    }
    
    ngOnInit(): void {
        this.activatedRoute.queryParamMap.subscribe((params: any) => {
            this.requestParams = { ...params.keys, ...params };
        });
        
        console.log('this.bookingRequest', this.bookingRequest);
        console.log(this.requestParams);
        this._apiService.processPayment(this.requestParams.params.id).subscribe(paymentData => {
            console.log(paymentData);
            this.isPaymentCompleted = true;
            this.bookingProcessStart = true;
            if (this.bookingRequest != null) {
                let parsedBookingRequest = JSON.parse(this.bookingRequest);
                parsedBookingRequest.paymentResponse = paymentData;
                const headers = { "Content-Type": "application/json" };
                this._apiService.bookFlight(parsedBookingRequest, headers).subscribe(
                    (data) => {
                    localStorage.removeItem('bookingRequest');
                      console.log(data);
                      this.bookingResponse = data;
                      if (data.success == true) {
                        this.isBookingCompleted = true;
                      } else {
                        this.isBookingError = true;
                      }
                    }
                  );
            }
            
        });
    }
}